export default "<ng-progress></ng-progress>\n<app-header></app-header>\n<app-layout></app-layout>\n<app-footer></app-footer>\n"